<template lang="pug">
    v-flex.pl-5.px-5(md12 )
            v-card
                v-toolbar(color='indigo' dark)
                    //- v-toolbar-side-icon
                    v-toolbar-title.white--text Haberes y descuentos asociados al contrato.
                v-list(v-if="items.length>0")
                    v-list-tile(v-for='item in headers' :key='item.name' avatar='' @click='')
                        v-list-tile-action
                        v-layout(row wrap)
                            v-flex(md4)
                                v-list-tile-title.headerStyle(v-text='item.name')
                            v-flex(md2)
                                v-list-tile-title.headerStyle(v-text='') {{item.type}}
                            v-flex(md2)
                                v-list-tile-title.headerStyle() {{item.created_at}}
                            v-flex(md2)
                                v-list-tile-title.headerStyle(v-text='') {{item.periodic}}
                            v-flex(md1)
                                v-list-tile-title.headerStyle(v-text='') {{item.amount}}
                    
                    v-divider
                v-list(v-if="items.length>0")
                    v-list-tile(v-for='item in items' :key='item.name' avatar='' @click='')
                        v-list-tile-action
                            v-icon( :color='item.icon_color') {{item.icon}}
                        v-layout(row wrap)
                            v-flex(md4)
                                v-list-tile-title(v-text='item.name')
                                //- v-list-tile-sub-title creado 30/10/2019
                            v-flex(md2)
                                v-list-tile-title(v-text='') {{item.type}}
                            v-flex(md2)
                                v-list-tile-title() {{item.created_at |mixFormatDate}}
                            v-flex(md2)
                                v-list-tile-title(v-text='') {{item.periodic}}
                            v-flex(md1)
                                v-list-tile-title(v-text='') {{item.amount |mixFormatCurrency}}
                v-alert(v-if="items.length==0" :value="true" type="info") No se encontraron asignados Haberes o descuentos al contrato.

                
                
</template>

<script>
/* mixins */
import DateUtils from '@/mixins/reusable_mixins/DateUtils'
import CurrencyUtils from '@/mixins/reusable_mixins/CurrencyUtils'
export default {
    name: 'employee-contract-asset-discount',
    props: {
        contract:{
            type:Object,
            require:true,
        },
    },
    data: function(){
        return {
            // items: [
            //     { created_at:'25/02/2018',amount:'$40.000',periodic:'Septiembre',icon_color:'success',icon:'add_circle', name: 'Bono navidad', type:'Imponible' },
            //     { created_at:'25/02/2018',amount:'$40.000',periodic:'Mensual',icon_color:'success',icon:'add_circle',name: 'Bono por hijo', type:'Imponible'  },
            //     { created_at:'25/02/2018',amount:'$40.000',periodic:'Septiembre',icon_color:'pink',icon:'remove_circle',name: 'Bono aguilnaldo fiestas patrias', type:'Legal'  },
            //     { created_at:'25/02/2018',amount:'$40.000',periodic:'Agosto',icon_color:'success',icon:'remove_circle',name: 'Aporte Fundacion las rosas', type:'Imponible'  }
            // ],
            headers: [
                { created_at:'Creado', amount:'Monto',periodic:'Periodo',icon_color:'success',icon:'add_circle', name: 'Nombre', type:'Tipo' },
            ],
            months:[
            'nada',//months[0]
            'Enero',
            'Febrero',
            'Marzo',
            'Abril',
            'Mayo',
            'Junio',
            'Julio',
            'Agosto',
            'Septiembre',
            'Octubre',
            'Noviembre',
            'Diciembre'
            ],
            items:[]
        }
    },
    // computed: {},
    methods: {
        // -- UI Modification
        // -- Data fetching
        // -- Data handling and transformations
        formatContractData(contract){
            let assetDiscounts = contract.hr_contract_asset_discount
            let arrAssetDiscountFormat=[]
            assetDiscounts.forEach(assetDiscount => {
                let item ={}
                item.created_at = assetDiscount.created_at
                item.amount = assetDiscount.amount
                item.type = assetDiscount.hr_asset_discount.hr_asset_discount_type.type
                item.periodic = (assetDiscount.periodic) ? 'Mensual' : this.months[parseInt(assetDiscount.periodic_month)]
                item.name = assetDiscount.hr_asset_discount.name
                item.icon = (item.type === "Imponible" || item.type==='No Imponible') ? 'add_circle' : 'remove_circle'
                item.icon_color = (item.type === "Imponible" || item.type==='No Imponible') ? 'success' : 'pink'
                arrAssetDiscountFormat.push(item)
            });
            
            this.items = arrAssetDiscountFormat
        }
        // -- Validations and Error handling
        // -- Other functions
        // -- Vuex mappings
    },
    // watch: {},
    // components: {},
    mixins: [DateUtils,CurrencyUtils],
    // filters: {},
    // -- Lifecycle Methods
    mounted () {
        this.formatContractData(this.contract)
    },
    // -- End Lifecycle Methods
}
</script>

<style lang="scss">
    .headerStyle{
        font-weight: bold;
    }
</style>